export enum CompleteActivityDismantledSeriesOrder {

    dismantledImages,
    serialAndPartNumbers,
    generalDismantledProperties
}